import _crud from './_crud';

const actions = _crud('bank_catalog', 'El catalogo de bancos', 'Los catalogos de bancos')

export default actions 